
export const API_ROUTE = {
    LOGIN: '/user/login',
    RESET_PASS: '/user/password/reset',
    NEW_PASS_RESET_CODE: '/user/password/new',
    CHANGE_PASSWORD: '/user/password',
    LOGOFF: '/user/logoff',
}